import React, {Component} from 'react';
import PageHeader from '../components/Headers/PageHeader';
import Divider from "../gadgets/Divider";
import {Helmet} from 'react-helmet';

class CoursesPage extends Component {
    render() {
        const headerContent = {
            tag: 'Learn About',
            title: 'The Courses',
            description: 'The University of Sydney School of Architecture, Design and Planning offers design programs for the industry leaders of tomorrow. Our students gain a toolbox of skills ranging from digital media production and user experience (UX) design through to visual design, effective communication and critical thinking. We offer a range of programs, from undergraduate to specialist postgraduate qualifications.',
            link: {
                href: 'https://sydney.edu.au/architecture'
            }
        };

        return (
            <div className={'container'}>
                <Helmet>
                    <title>Courses • D18</title>
                </Helmet>
                <PageHeader color={'red'} content={headerContent}/>
                <section>
                    <div className={'grid content__flex'}>
                        <div className={'col--6 col--center info'}>
                            <div className={'content'}>
                                <div className={'content__section'}>
                                    <h2>Bachelor of Design Computing</h2>
                                    <Divider color={'red'} type={'short'}/>
                                </div>
                                <div className={'content__section'}>
                                    <div>
                                        By taking the <a className={'link'}
                                                         href={"https://sydney.edu.au/courses/courses/uc/bachelor-of-design-computing.html"}
                                                         target={'_blank'}>Bachelor of Design Computing</a>, students
                                        learn how to create human-centred products and
                                        services. Students develop skills through studio projects in visual design,
                                        digital media production, coding,
                                        prototyping and UX design.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={'col--6 image-on-top'}>
                            <div className={'video-container'}>
                                <iframe title={'Bachelor of Design Computing Video'} width="100%" height="100%"
                                        src="https://www.youtube.com/embed/txNv5f_r-ug"
                                        frameBorder="0" allow="autoplay; encrypted-media" allowFullScreen>
                                </iframe>
                            </div>
                        </div>
                    </div>
                </section>
                <section className={'section--white'}>
                    <div className={'grid content__flex'}>
                        <div className={'col--6'}>
                            <div className={'video-container'}>
                                <iframe title={'Master of Design Video'} width="100%" height="100%"
                                        src="https://www.youtube.com/embed/d-EDTZ0Bo10"
                                        frameBorder="0" allow="autoplay; encrypted-media" allowFullScreen>
                                </iframe>
                            </div>
                        </div>
                        <div className={'col--6 col--center'}>
                            <div className={'content'}>
                                <div className={'content__section'}>
                                    <h2>Master of Interaction Design and Electronic Arts</h2>
                                    <Divider color={'red'} type={'short'}/>
                                </div>
                                <div className={'content__section'}>
                                    <div>The
                                        <a className={'link'}
                                           href={"https://sydney.edu.au/courses/courses/pc/master-of-interaction-design-and-electronic-arts.html"}
                                           target={'_blank'}> Master of Interaction Design and Electronic Arts </a>
                                        postgraduate
                                        program infuses
                                        technological innovation with human-centred design thinking. Students develop an
                                        understanding of ways to
                                        design interactive products and systems with lasting cultural and commercial
                                        value.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section>
                    <div className={'grid content__flex'}>
                        <div className={'col--12 col--center info'}>
                            <div className={'content'}>
                                <div className={'content__section'}>
                                    <h2>Master of Design (available from 2019)</h2>
                                    <Divider color={'red'} type={'short'}/>
                                </div>
                                <div className={'content__section'}>
                                    <div>The
                                        <a className={'link'}
                                           href={"https://sydney.edu.au/architecture/news-and-events/2018/09/18/master-of-design-become-a-strategic-leader.html"}
                                           target={'_blank'}> Master of Design </a>
                                        provides specialist postgraduate training in the emerging fields of design
                                        innovation and strategic design that can be applied across a wide range of
                                        disciplines. This degree introduces the principles and methods for using design
                                        to achieve innovation and strategic outcomes, and how to apply them in
                                        real-world design projects.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

export default CoursesPage;